(function () {
  function init(scope) {
    scope.querySelectorAll('[data-product]').forEach(function (product) {
      if (product.dataset.initialized) return;
      product.dataset.initialized = 'true';

      function showMedia(id) {
        if (!id || !product.querySelector('[data-media-panel="' + id + '"]')) return;
        product.querySelectorAll('[data-media-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.mediaPanel !== String(id);
          if (panel.hidden) {
            panel.querySelectorAll('video').forEach(function (video) { video.pause(); });
            // Reload a hidden external player to stop its audio when its view closes.
            panel.querySelectorAll('iframe').forEach(function (frame) {
              if (frame.dataset.wasActive === 'true') frame.src = frame.src;
              frame.dataset.wasActive = 'false';
            });
          } else {
            panel.querySelectorAll('iframe').forEach(function (frame) { frame.dataset.wasActive = 'true'; });
          }
        });
        product.querySelectorAll('[data-media-target]').forEach(function (button) {
          button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(id)));
        });
      }

      var mediaButtons = Array.from(product.querySelectorAll('[data-media-target]'));
      mediaButtons.forEach(function (button, index) {
        button.addEventListener('click', function () { showMedia(button.dataset.mediaTarget); });
        button.addEventListener('keydown', function (event) {
          var target;
          if (event.key === 'ArrowRight') target = (index + 1) % mediaButtons.length;
          if (event.key === 'ArrowLeft') target = (index - 1 + mediaButtons.length) % mediaButtons.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = mediaButtons.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          mediaButtons[target].focus();
          showMedia(mediaButtons[target].dataset.mediaTarget);
        });
      });
      product.dataset.galleryReady = 'true';
      var initialMedia = product.querySelector('[data-media-panel]:not([hidden])');
      if (initialMedia) showMedia(initialMedia.dataset.mediaPanel);

      product.querySelectorAll('[data-product-form]').forEach(function (root) {
        var variantInput = root.querySelector('[name="id"]');
        var form = root.closest('form');
        var price = product.querySelector('[data-product-price]');
        var payPrice = product.querySelector('[data-preorder-pay-price]');
        var comparePrice = product.querySelector('[data-product-compare-price]');
        var saleLabel = product.querySelector('[data-product-sale-label]');
        var availability = product.querySelector('[data-product-availability]');
        var submit = root.querySelector('[data-add-to-cart]');
        var sticky = product.querySelector('[data-sticky-buy]');
        var stickySubmit = product.querySelector('[data-sticky-submit]');
        var stickyPrice = product.querySelector('[data-sticky-price]');
        var message = root.querySelector('[data-selection-message]');
        var quantity = root.querySelector('[data-product-quantity]');
        var variants;
        var details = {};
        if (!variantInput || !submit || !form) return;
        try {
          variants = JSON.parse(root.querySelector('[data-product-variants]').textContent);
          var detailsNode = root.querySelector('[data-variant-details]');
          if (detailsNode) details = JSON.parse(detailsNode.textContent);
          if (!Array.isArray(variants) || !variants.length) return;
        } catch (_) { return; }
        var inputs = Array.from(root.querySelectorAll('[data-option-input]'));

        function formattedPrice(value) {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
            style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD'
          }).format(value / 100);
        }

        function setButtonState(variant) {
          var available = !!(variant && variant.available);
          var label = !variant ? 'Unavailable' : available
            ? (submit.dataset.preorderLabel || submit.dataset.atcLabel || 'Add to cart')
            : (submit.dataset.soldoutLabel || 'Sold out');
          submit.disabled = !available;
          submit.textContent = label;
          if (stickySubmit) { stickySubmit.disabled = !available; stickySubmit.textContent = label; }
        }

        function update(changeUrl) {
          var selected = {};
          inputs.forEach(function (input) {
            if (input.disabled) return;
            if (input.checked) selected[input.dataset.optionIndex] = input.value;
          });
          var variant = inputs.length ? variants.find(function (item) {
            return item.options.every(function (option, index) { return selected[index] === option; });
          }) : variants.find(function (item) { return String(item.id) === variantInput.value; });

          // Explain availability in the context of the other selections, without trapping the shopper.
          inputs.forEach(function (input) {
            var available = variants.some(function (item) {
              return item.available && item.options.every(function (option, index) {
                return option === (String(index) === input.dataset.optionIndex ? input.value : selected[index]);
              });
            });
            var label = input.closest('.variant-option');
            if (label) label.dataset.optionAvailable = String(available);
          });

          variantInput.value = variant ? String(variant.id) : '';
          setButtonState(variant);
          if (message) {
            message.hidden = !!(variant && variant.available);
            message.textContent = !variant ? 'This combination is unavailable. Choose another option.'
              : !variant.available ? (variants.some(function (item) { return item.available; })
                ? 'This option is sold out. Choose another available option.' : 'This product is currently sold out.') : '';
          }
          if (comparePrice) comparePrice.hidden = !(variant && variant.compare_at_price > variant.price);
          if (saleLabel) saleLabel.hidden = !(variant && variant.compare_at_price > variant.price);

          if (variant) {
            var detail = details[String(variant.id)] || {};
            var priceMarkup = detail.price || formattedPrice(variant.price);
            // Price HTML comes exclusively from Shopify's server-rendered money filter.
            if (price) price.innerHTML = priceMarkup;
            if (payPrice) payPrice.innerHTML = priceMarkup;
            if (stickyPrice) stickyPrice.innerHTML = priceMarkup;
            if (comparePrice && !comparePrice.hidden) {
              var compareValue = comparePrice.querySelector('[data-compare-value]');
              if (compareValue) compareValue.innerHTML = detail.comparePrice || formattedPrice(variant.compare_at_price);
            }
            if (availability) {
              var stockLabel = detail.stock || (variant.available ? 'Available to order' : 'Currently sold out');
              availability.textContent = stockLabel;
              availability.dataset.available = String(variant.available);
              availability.classList.remove('product-availability--hot');
            }
            if (quantity) {
              var min = Number(detail.quantityMin) || 1;
              quantity.min = min;
              quantity.step = Number(detail.quantityStep) || 1;
              if (detail.quantityMax != null) quantity.max = detail.quantityMax;
              else quantity.removeAttribute('max');
              if (quantity.value !== '' && !quantity.checkValidity()) quantity.value = min;
            }
            var mediaId = detail.mediaId || (variant.featured_media && variant.featured_media.id);
            if (!mediaId && variant.featured_image) {
              // Image IDs and product media IDs are different Shopify resources.
              var panel = product.querySelector('[data-media-image-id="' + variant.featured_image.id + '"]');
              if (panel) mediaId = panel.dataset.mediaPanel;
            }
            if (changeUrl) showMedia(mediaId);
          } else {
            if (price) price.textContent = 'Unavailable';
            if (payPrice) payPrice.textContent = '—';
            if (stickyPrice) stickyPrice.textContent = 'Unavailable';
            if (availability) {
              availability.textContent = 'Choose another combination';
              availability.dataset.available = 'false';
              availability.classList.remove('product-availability--hot');
            }
          }
          if (changeUrl) {
            var url = new URL(window.location.href);
            if (variant) url.searchParams.set('variant', variant.id);
            else url.searchParams.delete('variant');
            window.history.replaceState({}, '', url);
          }
        }

        function applyColourStock(stockByColour) {
          if (!stockByColour || typeof stockByColour !== 'object') return;
          root.querySelectorAll('[data-colour-stock]').forEach(function (node) {
            var colour = node.getAttribute('data-colour-stock');
            if (!Object.prototype.hasOwnProperty.call(stockByColour, colour)) return;
            var qty = stockByColour[colour];
            if (qty == null) return;
            qty = Number(qty);
            if (!isFinite(qty) || qty < 0) qty = 0;
            node.classList.remove('variant-option-stock--empty');
            node.removeAttribute('aria-hidden');
            node.textContent = qty + ' left';
          });
          variants.forEach(function (item) {
            var colour = item.options && item.options[0];
            if (colour == null || stockByColour[colour] == null) return;
            var detail = details[String(item.id)] || (details[String(item.id)] = {});
            detail.inventory = Number(stockByColour[colour]);
          });
        }

        function refreshColourStock() {
          var url = new URL(window.location.pathname, window.location.origin);
          url.searchParams.set('view', 'stock');
          url.searchParams.set('t', String(Date.now()));
          fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (response) { return response.ok ? response.text() : Promise.reject(); })
            .then(function (text) {
              var payload = JSON.parse(text.trim());
              applyColourStock(payload.colours || payload);
            })
            .catch(function () {});
        }

        var colourStockNode = root.querySelector('[data-colour-stock-json]');
        if (colourStockNode) {
          try { applyColourStock((JSON.parse(colourStockNode.textContent) || {}).colours); } catch (_) {}
        }

        inputs.forEach(function (input) { input.addEventListener('change', function () { update(true); }); });
        variantInput.addEventListener('change', function () {
          var variant = variants.find(function (item) { return String(item.id) === variantInput.value; });
          if (variant) inputs.forEach(function (input) {
            if (input.disabled) { input.checked = false; return; }
            input.checked = variant.options[Number(input.dataset.optionIndex)] === input.value;
          });
          update(true);
        });
        form.addEventListener('submit', function (event) { if (submit.disabled || !variantInput.value) event.preventDefault(); });
        update(false);
        root.dataset.enhanced = 'true';
        submit.hidden = false;
        var enhancedOptions = root.querySelector('[data-enhanced-options]');
        if (enhancedOptions) enhancedOptions.hidden = false;
        if (!product._colourStockRefresh) {
          product._colourStockOnShow = function () {
            if (document.visibilityState === 'visible') refreshColourStock();
          };
          document.addEventListener('visibilitychange', product._colourStockOnShow);
          window.addEventListener('pageshow', product._colourStockOnShow);
          product._colourStockRefresh = window.setInterval(refreshColourStock, 45000);
        }
        if (sticky && 'IntersectionObserver' in window) {
          var stickyFrame = 0;
          function updateSticky() {
            stickyFrame = 0;
            // A fast scroll can jump from below to above the viewport without
            // changing intersection state. Read the final position once per frame.
            sticky.hidden = submit.getBoundingClientRect().bottom >= 0;
          }
          function scheduleSticky() {
            if (!stickyFrame) stickyFrame = window.requestAnimationFrame(updateSticky);
          }
          var observer = new IntersectionObserver(scheduleSticky, { threshold: 0 });
          observer.observe(submit);
          window.addEventListener('scroll', scheduleSticky, { passive: true });
          window.addEventListener('resize', scheduleSticky, { passive: true });
          root.productObserver = observer;
          root.productStickyCleanup = function () {
            observer.disconnect();
            window.removeEventListener('scroll', scheduleSticky);
            window.removeEventListener('resize', scheduleSticky);
            if (stickyFrame) window.cancelAnimationFrame(stickyFrame);
          };
          scheduleSticky();
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-product-form]').forEach(function (root) {
      var host = root.closest('[data-product]');
      if (host && host._colourStockRefresh) {
        window.clearInterval(host._colourStockRefresh);
        document.removeEventListener('visibilitychange', host._colourStockOnShow);
        window.removeEventListener('pageshow', host._colourStockOnShow);
        host._colourStockRefresh = null;
      }
      if (root.productStickyCleanup) root.productStickyCleanup();
      else if (root.productObserver) root.productObserver.disconnect();
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') document.querySelectorAll('.cv-menu[open]').forEach(function (menu) { menu.open = false; menu.querySelector('summary').focus(); });
  });
})();
